import styles from "./style.module.scss";

export const TextSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <p>
          株式会社あいホーム（以下「当社」といいます。）は、当社が運営する宿泊施設「石巻マリンヴィレッジ」（以下「当施設」といいます。）の宿泊について、以下のとおり宿泊約款（以下「本約款」といいます。）を定めます。
        </p>
        <br />
        <br />
        <p>第1条 適用範囲</p>
        <ul>
          <li>
            本約款は、当施設が宿泊客（以下「宿泊者」といいます。）との間で締結する宿泊契約およびこれに関連する契約に適用されるものとします。
          </li>
          <li>
            本約款に定めのない事項については、法令または一般に確立された慣習によるものとします。
          </li>
          <li>
            当施設が、法令および慣習に反しない範囲で特約に応じたときは、前項の規定にかかわらず、その特約が優先するものとします。
          </li>
        </ul>
        <br />
        <br />
        <p>第2条 宿泊契約の申込みと成立</p>
        <ul>
          <li>
            当施設に宿泊契約の申込みをしようとする者は、以下の事項を当社に通知する必要があります。
            <ol>
              <li>宿泊者の氏名、住所、電話番号、メールアドレス</li>
              <li>宿泊日、宿泊日数、到着予定時刻</li>
              <li>宿泊人数</li>
              <li>その他当施設が必要と認める事項</li>
            </ol>
          </li>
          <li>
            前項の申込みに対し、当社が承諾したときに宿泊契約は成立するものとします。
          </li>
          <li>
            当社は、宿泊契約の成立後、予約を確定した旨を宿泊者に通知します。通知の方法は、原則としてメールによるものとします。また、宿泊日直前にメールによる確認連絡を行うことがあります。
          </li>
        </ul>
        <br />
        <br />
        <p>第3条 宿泊契約締結の拒否</p>
        <ul>
          <li>
            当社は、以下の場合において、宿泊契約の締結に応じないことがあります。
            <ol>
              <li>宿泊の申込みが本約款に合致しない場合</li>
              <li>満室により客室に空きがない場合</li>
              <li>
                宿泊しようとする者が、宿泊に関し、法令の規定、公の秩序若しくは善良の風俗に反する行為をするおそれがあると認められる場合
              </li>
              <li>
                宿泊しようとする者が、伝染病者であると明らかに認められる場合
              </li>
              <li>宿泊に関し合理的な範囲を超える負担を求められた場合</li>
              <li>
                天災、施設の故障、その他やむを得ない事由により宿泊させることができない場合
              </li>
              <li>
                宿泊しようとする者が泥酔者等で、他の宿泊者に著しく迷惑を及ぼすおそれがある場合
              </li>
              <li>
                宿泊しようとする者が、当施設内で合理的な理由のない苦情、要求を申し立てた等、当施設の平穏な秩序を乱すおそれがあると認められる場合
              </li>
              <li>
                宿泊しようとする者が暴力団、暴力団員、暴力団関係企業・団体の関係者などの反社会的勢力である場合
              </li>
              <li>
                過去に当該ゲストハウスに対して宿泊料金の支払いの遅延などの事象が認められた場合
              </li>
              <li>
                宿泊の申込みをした者が、予約した部屋につき、転売や有料での斡旋など自己の利益を図る目的を秘して申し込みをした場合
              </li>
              <li>
                宿泊者が、感染症のまん延防止に必要な対策への協力要請に応じない場合
              </li>
              <li>
                予約時に示された利用目的が、当施設の運営意図にそぐわないと判断される場合
              </li>
            </ol>
          </li>
          <li>
            前項第13号に該当する場合、当社は、不適切とみなされる利用目的について、具体的に説明するよう努めるものとします。
          </li>
        </ul>
        <br />
        <br />
        <p>第4条 宿泊の登録</p>
        <ul>
          <li>
            宿泊者は、チェックイン時に、以下の情報を当施設に登録する必要があります。
            <ol>
              <li>宿泊者の氏名</li>
              <li>宿泊者の住所</li>
              <li>宿泊者の連絡先</li>
              <li>宿泊者の年齢</li>
              <li>宿泊者の性別</li>
              <li>到着年月日及び出発年月日</li>
              <li>前宿泊地及び行先地</li>
              <li>宿泊者の職業（ただし、収集しない場合もあります。）</li>
              <li>
                国籍、旅券番号（日本国内に住所を持たない外国人宿泊者のみ）
              </li>
            </ol>
          </li>
          <li>
            日本国内に住所を持たない外国人宿泊者は、パスポートの提示が必要です。　また、提示されたパスポートの写しを保管することがあります。
          </li>
          <li>
            複数人で予約する場合、予約者は、同行者全員の氏名や必要な情報を提供する責任を負うものとします。
          </li>
        </ul>
        <br />
        <br />
        <p>第5条 客室の使用</p>
        <ul>
          <li>
            宿泊者は、当施設が定めるチェックイン時刻からチェックアウト時刻まで、客室を使用することができます。
          </li>
          <li>
            当施設の客室は、登録された宿泊者のみが利用できるものとします。
          </li>
          <li>
            宿泊者は、当施設内において、以下の行為をしてはなりません。
            <ol>
              <li>
                他の宿泊者や居住者、近隣住民の迷惑となる行為（騒音、大声での会話など）
              </li>
              <li>
                火災の原因となる行為（指定場所以外での喫煙、暖房器具や調理器具の無断使用など）
              </li>
              <li>公序良俗に反する行為（賭博など）</li>
              <li>危険物の持ち込み（可燃性物質、爆発物など）</li>
              <li>
                事前の許可を得ていない商業目的の利用（イベント開催、撮影など）
              </li>
            </ol>
          </li>
          <li>
            連泊の場合の客室清掃については、基本的には実施いたしません。清掃が必要な場合は、宿泊者による実施をお願いしております。
          </li>
        </ul>
        <br />
        <br />
        <p>第6条 料金及び支払い</p>
        <p>宿泊者が支払うべき宿泊料金等の内訳は、以下のとおりとします。</p>
        <br />
        <br />
        <p>第7条 予約の変更・解除</p>
        <ul>
          <li>
            宿泊者は、当施設が定める方法により、予約内容の変更を申し出ることができます。予約内容の変更については、変更可能な期間や、変更に伴う手数料の発生などを定めるものとします。
          </li>
          <li>
            宿泊者が宿泊契約を解除する場合、当施設が定めるキャンセル料を支払うものとします。キャンセル料は、宿泊日からの日数に応じて、以下のとおり定めます。
            <ul className={styles.disc}>
              <li>宿泊日の5日前まで：無料</li>
              <li>宿泊日の5日前から2日前まで：宿泊料金の50%</li>
              <li>宿泊日の2日前以降：宿泊料金の100%</li>
            </ul>
          </li>
          <li>
            宿泊者が宿泊日数を短縮する場合も、前項と同様にキャンセルとして扱うことがあります。
          </li>
          <li>
            当社は、以下の場合において、宿泊契約を解除することがあります。
            <ul className={styles.disc}>
              <li>宿泊者が、本約款または利用規則に違反した場合</li>
              <li>
                天災その他の不可抗力により宿泊を提供することが困難になった場合
              </li>
              <li>
                その他、当施設が宿泊契約の解除を必要と認める相当の理由がある場合
              </li>
            </ul>
          </li>
          <li>
            当社は、前項の規定により宿泊契約を解除した場合、可能な限り同一条件の他の宿泊施設を斡旋するよう努めるものとします。代替の宿泊施設を斡旋できない場合は、キャンセル料相当額の補償金を支払うことがあります。
          </li>
          <li>
            宿泊者が、事前に連絡なく到着予定時刻を過ぎても到着しない場合、予約はキャンセルされたものとみなし、前項のキャンセル料を申し受けることがあります。
          </li>
        </ul>
        <br />
        <br />
        <p>第8条 当施設の責任及び免責</p>
        <ul>
          <li>
            当施設は、宿泊契約に基づき、宿泊者に安全で快適な宿泊を提供するために必要な措置を講じるものとします。
          </li>
          <li>
            当施設は、当施設の故意または過失によって宿泊者に損害を与えた場合、その損害を賠償する責任を負います。
          </li>
          <li>当施設は、以下の場合において、責任を負わないものとします。</li>
          <ol>
            <li>天災地変その他の不可抗力による損害</li>
            <li>宿泊者の不注意による事故</li>
            <li>フロントに預けられなかった貴重品の盗難、紛失または破損</li>
          </ol>
          <li>
            当施設内に金庫などが設置されている場合は、その利用に関する注意点を別途定めるものとします。
          </li>
        </ul>
        <br />
        <br />
        <p>第9条 宿泊者の責任</p>
        <ul>
          <li>宿泊者は、本約款を遵守しなければなりません。</li>
          <li>
            宿泊者は、当施設の施設や備品を故意または過失により破損、汚損、または紛失した場合、その損害を賠償する責任を負います。
          </li>
          <li>
            宿泊者は、予約時またはチェックイン時に登録した情報が正確であることを保証するものとします。
          </li>
        </ul>
        <br />
        <br />
        <p>第10条 手荷物及び携帯品の取扱い</p>
        <ul>
          <li>
            当施設は、原則として、チェックイン前やチェックアウト後の手荷物のお預かりには対応しておりません。
          </li>
          <li>
            特別な事情により、当施設が手荷物をお預かりする場合は、その条件や責任範囲を別途定めるものとします。
          </li>
          <li>
            当施設における忘れ物や遺失物の取り扱いについては、別途定める利用規則によるものとします。
          </li>
        </ul>
        <br />
        <br />
        <p>第11条 緊急時対応</p>
        <ul>
          <li>
            当施設内での緊急事態（火災、地震など）発生時の対応と避難経路については、施設内に掲示します。
          </li>
          <li>
            緊急連絡先（管理者、警察、消防署など）についても、施設内に分かりやすく掲示します。
          </li>
          <li>
            当施設は、予約時またはチェックイン時に、宿泊者の緊急連絡先を提供してもらうようお願いすることがあります。
          </li>
        </ul>
        <br />
        <br />
        <p>第12条 個人情報の取扱い</p>
        <p>
          宿泊者の個人情報の取り扱いについては、別途定める個人情報保護方針によるものとします。
        </p>
        <br />
        <br />
        <p>第13条 その他</p>
        <ul>
          <li>
            当施設に駐車場がある場合は、その有無、料金、利用条件（予約の要否、台数制限など）について、別途定めるものとします。
          </li>
          <li>
            当施設がWi-Fiなどのインターネット接続を提供している場合は、その利用規約への同意を求める条項や、サービスの可用性やセキュリティに関する免責事項などを別途定めることがあります。
          </li>
          <li>本約款に関する準拠法は、日本法とします。</li>
          <li>
            宿泊者と当社との間で紛争が生じた場合は、当施設の所在地を管轄する裁判所を第一審の専属的合意管轄裁判所とします。
          </li>
        </ul>
        <p>第14条 付則</p>
        <ul>
          <li>本約款は、2025年4月9日より効力を生じるものとします。</li>
          <li>
            本約款の内容は、必要に応じて変更することがあります。変更する場合は、当施設のウェブサイトに掲載する方法により告知するものとします。
          </li>
        </ul>
      </div>
    </section>
  );
};
